import { useRouteMatch } from 'react-router-dom';
import { FlowViewConfigs } from 'automation-ui-canvas/containers/flow-views/FlowViewConfigs';
import FlowViewDefaultMenuBar from 'automation-ui-canvas/components/flow-header/menu-bar/FlowViewDefaultMenuBar';
import { jsx as _jsx } from "react/jsx-runtime";
const FlowViewMenuBar = ({
  flow,
  canvasScrollElementRef
}) => {
  const {
    params
  } = useRouteMatch();
  const flowConfig = FlowViewConfigs[params.viewId];
  return flowConfig && flowConfig.menuBar ? flowConfig.menuBar.MenuBarComponent ? /*#__PURE__*/_jsx(flowConfig.menuBar.MenuBarComponent, {
    flow: flow,
    canvasScrollElementRef: canvasScrollElementRef
  }) : /*#__PURE__*/_jsx(FlowViewDefaultMenuBar, {
    flow: flow,
    canvasScrollElementRef: canvasScrollElementRef
  }) : null;
};
export default FlowViewMenuBar;